import { IPayeeResponse } from "@wingspanhq/payments/dist/interfaces";
import { wsName, WSNameParams } from "@wingspanhq/utils/dist/name/wsName";

export const getPayeeNames = (payee: IPayeeResponse) => {
  const { user, member, payerOwnedData } = payee;
  return wsName({ user, member, payerOwnedData } as WSNameParams);
};
